import React from "react";
import {
  Box,
  Typography,
  Container,
  useMediaQuery,
  Button,
} from "@mui/material";
import backgroundImage from "../../assets/Bathroom.webp";
import { useNavigate, useLocation } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";

const Header = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate();
  const location = useLocation();

  const handlePageClick = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        scrollToSection(id);
      }, 300);
    } else {
      scrollToSection(id);
    }
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: { xs: "20px 10px", md: "40px 20px" },
        color: "white",
        position: "relative",
        textAlign: "left",
        height: { xs: "auto", md: "70vh" },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "center", md: "flex-end" },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1,
        }}
      />
      <Container
        sx={{
          position: "relative",
          zIndex: 2,
          marginBottom: { xs: "10px", md: "20px" },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 2, md: 4 },
          alignItems: { xs: "center", md: "flex-start" },
        }}
      >
        <Box
          sx={{
            borderLeft: { xs: "10px solid #4e77fa", md: "5px solid #4e77fa" },
            paddingLeft: { xs: "0", md: "15px" },
            width: { xs: "100%", md: "70%" },
            textAlign: { xs: "start", md: "left" },
          }}
        >
          <Typography
            variant="h6"
            component="div"
            sx={{ marginLeft: isMobile ? "20px" : "0" }}
          >
            CHICAGO REMODELING CONTRACTOR
          </Typography>
          <Typography
            variant={isMobile ? "h3" : "h2"}
            component="div"
            sx={{ fontWeight: "bold", marginLeft: isMobile ? "20px" : "0" }}
          >
            Full Service Bathroom Remodeling
          </Typography>
          <Typography
            variant="h5"
            component="div"
            sx={{ marginLeft: isMobile ? "20px" : "0" }}
          >
            Make your dream bathroom a reality with help from our team of
            remodeling experts.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginTop: { xs: "10px", md: "20px" },
            alignItems: { xs: "start", md: "flex-start" },
          }}
        >
          {[
            "FREE PROJECT ESTIMATE",
            "100% SATISFACTION GUARANTEED",
            "LOCALLY OWNED & OPERATED",
            "WE HANDLE DESIGN & PERMITS",
          ].map((point, index) => (
            <Typography
              key={index}
              variant="body1"
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <Box
                component="span"
                sx={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  backgroundColor: "#4e77fa",
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "10px",
                }}
              >
                ✔
              </Box>
              {point}
            </Typography>
          ))}
        </Box>
      </Container>
      {isMobile && (
        <Button
          variant="contained"
          sx={{
            width: "80%",
            backgroundColor: "#4e77fa",
            fontSize: "14px",
            textTransform: "uppercase",
            padding: "16px 30px 16px 30px",
            zIndex: 2,
          }}
          onClick={() => handlePageClick("requestForm")}
        >
          REQUEST FREE ESTIMATE
        </Button>
      )}
    </Box>
  );
};

export default Header;
